import script from "./LocalOnlyView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalOnlyView.vue?vue&type=script&setup=true&lang=js"

import "./LocalOnlyView.vue?vue&type=style&index=0&id=d9661724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9661724"]])

export default __exports__